import { createContext, Dispatch, SetStateAction } from "react";

import { FormInstance } from "antd";

import { DebtQuote } from "../../../../shared/interfaces/services/get-debt-columns-service.interface";
import { SavedPreliquidation } from "../../interfaces";

interface StepOneFormContextProps {
    filterForm:                         FormInstance<any>;

    checkboxList:                       Array<string>;
    totalSelected:                      number;

    preliquidationData:                 Array<DebtQuote>;
    setPreliquidationData:              Dispatch<SetStateAction<Array<DebtQuote>>>;

    preliquidationDataWithFilters:      Array<DebtQuote>;
    setPreliquidationDataWithFilters:   Dispatch<SetStateAction<Array<DebtQuote>>>;

    savedPreliquidationData:            SavedPreliquidation;
    setSavedPreliquidationData:         Dispatch<SetStateAction<SavedPreliquidation>>;

    showConfirmationModal:              boolean;
    setShowConfirmationModal:           Dispatch<SetStateAction<boolean>>;

    //* Methods
    hasSelections:                      () => boolean;
    filterPreliquidationData:           () => void;
    clearPreliquidationData:           () => Array<DebtQuote>;
    updateRowCheckboxState:             (recordKey: string, column: string, checked: boolean) => void;
    updateColumnCheckboxStateForVisible: (column: string, checked: boolean) => void;
}

export const StepOneFormContext = createContext({} as StepOneFormContextProps);